module.exports = __webpack_public_path__ + "static/fonts/dfyuanstd-w5.f3c5fb0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/dfyuanstd-w5.otf
// module id = mpnd
// module chunks = 1